<script setup lang="ts">
definePageMeta({
  middleware: ['user-auth'],
})
const { recaptchaKey } = useEnvs()
</script>

<template>
  <IaResendEmailPage
    :recaptcha-key="recaptchaKey"
  />
</template>
